import { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  TextField,
  Grid,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Slide,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/* eslint-enable */

DateRangePickerDialog.propTypes = {
  openDateRangeModal: PropTypes.bool,
  handleClose: PropTypes.func,
  onAction: PropTypes.func,
  onDismiss: PropTypes.func
};

export default function DateRangePickerDialog({ openDateRangeModal, handleClose, onAction, onDismiss }) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  return (
    <Dialog
      open={openDateRangeModal}
      TransitionComponent={Transition}
      keepMounted
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return; // ignore
        }
        handleClose();
      }}
      aria-describedby="date-range-dialog-slide-description"
      data-cy="date-range-dialog"
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          fontFamily: 'Montserrat',
          fontWeight: 600
        }}
      >
        Select Date range
        <IconButton
          edge="end"
          onClick={() => {
            handleClose();
            onDismiss?.();
          }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="date-range-dialog-slide-description">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Start Date{' '}
                </Typography>

                <DatePicker
                  openTo="day"
                  views={['year', 'month', 'day']}
                  value={startDate}
                  onChange={handleStartDateChange}
                  maxDate={dayjs()}
                  slots={{
                    textField: TextField
                  }}
                  slotProps={{
                    textField: {
                      inputProps: { 'data-cy': 'start-date-input' }
                    }
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  End Date{' '}
                </Typography>
                <DatePicker
                  openTo="day"
                  views={['year', 'month', 'day']}
                  value={endDate}
                  maxDate={dayjs()}
                  minDate={startDate}
                  onChange={handleEndDateChange}
                  slots={{
                    textField: TextField
                  }}
                  slotProps={{
                    textField: {
                      inputProps: { 'data-cy': 'end-date-input' }
                    }
                  }}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onAction(startDate, endDate);
            handleClose();
            handleStartDateChange(null);
            handleEndDateChange(null);
          }}
          data-cy="date-range-apply"
          variant="contained"
          sx={{ mr: 2, mb: 2, borderRadius: 2 }}
        >
          Filter
        </Button>
      </DialogActions>
    </Dialog>
  );
}
